import {
  TOrderInputType,
} from './pt9800-loading-place';

const orderInputType: Record<TOrderInputType, string> = {
  keyboard: 'Klawiatura',
  scanner: 'Skaner',
};

export default {
  orderInputType,
  orderInputlabel: 'Typ wprowadzania zlecenia',
  loadingPlace: 'Miejsce załadunku',
  orderInput: 'Zlecenie',
  priority: 'Priorytet',
  processFlowNo: 'Nr procesu',
  box: 'Skrzynia',
  cellChargeNo: 'Nr ładunku komórki',
  comment1: 'Komentarz 1',
  comment2: 'Komentarz 2',
  comment3: 'Komentarz 3',
  placeStatus: 'Status miejsca',
  locked: 'zablokowane',
  loadBookedAndReady: 'Ładunek zarezerwowany i gotowy',
  enableLoadForAutomatic: 'Włącz ładunek do automatyki',
  loadbookingEnded: 'Rezerwacja ładunku zakończona',
  camera: 'Kamera',
  noOrderLoaded: 'Nie załadowano zamówienia',
};
